import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(4),
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '22px',
    margin: theme.spacing(1),
  },
  menuButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'auto',
    width: '100%',
    flex: 1,
    padding: theme.spacing(2),
    scrollBehavior: 'smooth',
    gap: '8px',
    marginBottom: theme.spacing(2),
    maxHeight: theme.spacing(8),
  },

  button: {
    fontSize: '13px',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(0.2),
    paddingTop: theme.spacing(0.2),
    margin: theme.spacing(0.2),
    marginBottom: theme.spacing(2),
    borderRadius: 25,
    border: '2px solid black',
  },
  break: {
    width: '100%',
    height: 0,
  },
}));
